import { render } from "./BaseSearch.vue?vue&type=template&id=c8b21a48&scoped=true"
import script from "./BaseSearch.vue?vue&type=script&lang=js"
export * from "./BaseSearch.vue?vue&type=script&lang=js"

import "./BaseSearch.vue?vue&type=style&index=0&id=c8b21a48&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8b21a48"]])

export default __exports__